<template>
  <div id="app">
    <!-- 这里是会被缓存的视图组件-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 这里是不被缓存的视图组件-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  mounted() {}
};
</script>

<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
  font-family: "微软雅黑";
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
input {
  margin: 0;
  padding: 0;
}
body {
  overflow-x: hidden;
}
#app {
}
.van-dialog {
  width: 6.293333rem;
  height: 5.5rem;;
  border-radius: 8px;
  padding: 0 30px;
  .van-dialog__header {
    height: 1.2rem;
    line-height: 1.5rem;
    font-size: 0.5rem;
    color: #333333;
    padding: 0;
    border-bottom: 1px solid #e4e4e4;
  }
  .van-dialog__content{
    height: 2.7rem;
    overflow: auto;
  }
  .van-dialog__message--has-title {
    padding-top: 0.5rem;
    font-size: 0.4rem;
    min-height: 1.2rem;
    line-height: 0.55rem;
  }
  .van-dialog__footer {
    height: 0.64rem;
    margin-top: 0.3rem;
    .van-button__text {
      color: #3a8bf2;
      font-size: 32px;
    }
  }
}

.loading-mask {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  /*height: 100%;*/
  background-color: #fff;
  opacity: 0.7;
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    padding: 20px;
    transform: translate(-50%, -50%);
    background-color: #7c7c7c;
    z-index: 99;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue